import * as React from "react";
import {CrudPage} from "../crud/CrudPage";
import {observable} from "mobx";
import {CrudForm} from "../crud/CrudForm";
import {CrudList} from "../crud/CrudList";
import {Input} from "../form/fields/Input";
import {Field} from "../form/Field";
import {BooleanRadios} from "../form/fields/BooleanRadios";
import {Select} from "../form/fields/Select";
import {api} from "../../api";
import {Col, Row, Container} from "reactstrap";
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export class StateConstituencyFormData {
    @observable code = '';
    @observable name = '';
    @observable state_id: number|null = null;
    @observable is_active = true;
    @observable wards = [];
}

export class StateConstituencyForm extends CrudForm {
    modelName = 'StateConstituency';

    renderFields() {
        return (
            <>
                <Field
                    label="Code"
                    name="code"
                    component={Input}
                    required={true}
                    store={this.formStore}
                />

                <Field
                    label="Constituency"
                    name="name"
                    component={Input}
                    required={true}
                    store={this.formStore}
                />

                <Field
                    label="State"
                    name="state_id"
                    component={Select}
                    required={true}
                    loadOptions={api.state.getListAction}
                    store={this.formStore}
                    onChange={() => {
                        this.formStore.setValue('wards', []);
                    }}
                />

                <Field
                    key={this.formStore.getValue('state_id')}
                    label="Wards"
                    name="wards"
                    component={Select}
                    multi={true}
                    required={true}
                    valueObject={true}
                    loadOptions={() => {
                        return api.ward.getListAction({
                            filters: {
                                state_id: this.formStore.getValue('state_id')
                            }
                        });
                    }}
                    store={this.formStore}
                />

                <Field
                    name="is_active"
                    component={BooleanRadios}
                    trueLabel="Active"
                    falseLabel="In-Active"
                    store={this.formStore}
                />
            </>
        );
    }
}

export class StateConstituencyFilterForm {
    @observable name = '';
}

export class StateConstituencyList extends CrudList {
    modelName = 'StateConstituency';

    defaultSortColumn = 'state.name';
    defaultSortDirection = 'asc';

    colums() {
        return [
            {
                name: "state.code",
                label: "State Code",
                sort: true,
            },
            {
                name: "state.name",
                label: "State",
                sort: true,
            },
            {
                name: "name",
                label: "State Cons.",
                sort: true,
            },
            {
                name: "code",
                label: "State Cons. Code",
                sort: true,
            },
        ];
    }

    idColumn() {
        return '';
    }

    renderFilters() {
        return (

            <Container>
            <Row className="form-row">
                    <Col md={5}>
                        <ToastContainer autoClose={5000} />
                    </Col>
            </Row>
            <Row className="form-row">
                <Col md={3} lg={4} xl={3}>
                    <Field
                        placeholder="Name"
                        name="name"
                        component={Input}
                        store={this.filterFormStore}
                    />
                </Col>

                <Col md={3} lg={4} xl={3} className="grid-search">
                    {this.renderSearch()}
                </Col>
            </Row>
            </Container>
        );
    }
}

export class StateConstituencyPage extends CrudPage {
    modelName = 'StateConstituency';
}



// WEBPACK FOOTER //
// ./resources/js/components/pages/StateConstituencyPage.tsx